import { CampoDestinoCancelamentoView } from "./view-campo-destino-cancelamento";
import type { CampoDestinoCancelamentoProps } from "./types-campo-destino-cancelamento";

export function CampoDestinoCancelamento<T extends string>(
  props: CampoDestinoCancelamentoProps<T>,
) {
  return <CampoDestinoCancelamentoView {...props} />;
}

export { DESTINO_LABEL, DESTINO_OBRIGATORIO } from "./campo-destino-cancelamento.constants";
export type * from "./types-campo-destino-cancelamento";
